import { render, staticRenderFns } from "./RoomOther.vue?vue&type=template&id=05298c64&scoped=true"
import script from "./RoomOther.vue?vue&type=script&lang=ts"
export * from "./RoomOther.vue?vue&type=script&lang=ts"
import style0 from "./RoomOther.vue?vue&type=style&index=0&id=05298c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05298c64",
  null
  
)

export default component.exports